import { render } from "./IntroContent.vue?vue&type=template&id=6bcaa310&scoped=true"
import script from "./IntroContent.vue?vue&type=script&lang=ts"
export * from "./IntroContent.vue?vue&type=script&lang=ts"

import "./IntroContent.vue?vue&type=style&index=0&id=6bcaa310&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6bcaa310"

export default script